type SuccessModalProps = {
  open: boolean
  onClose: () => void
}

export function SuccessModal({ open, onClose }: SuccessModalProps) {
  if (!open) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
      <div className='absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity' />
      <div className='relative z-10 w-full max-w-[731px] min-h-[198px] bg-white rounded-2xl shadow-2xl overflow-hidden mx-4'>
        {/* Close button */}
        <button onClick={onClose} className='absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10'>
          <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' />
          </svg>
        </button>

        <div className='px-10 py-14 flex flex-col items-center justify-center text-center space-y-5'>
          <div className='flex items-center justify-center gap-2'>
            <span className='text-4xl'>🎉</span>
            <h3 className='text-4xl font-bold text-gray-900'>Success!</h3>
          </div>

          <p className='text-base text-gray-600 leading-relaxed max-w-md'>
            You have successfully mapped modality to cluster,to <strong>view</strong> the mapped cluster see the{' '}
            <a href='/modalities' className='text-blue-600 hover:text-blue-700 underline font-medium'>
              modality manager dashboard
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  )
}
